import styled from 'styled-components'
import { Typography, Divider } from '@material-ui/core'

export const Title = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '16px',
})

export const ShopLabel = styled(Typography)({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: '210px',
})

export const ItemContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
})

export const StyledDivider = styled(Divider)({
  width: '100%',
  marginBlock: '8px',
})

export const StatusIcon = styled.div({
  display: 'flex',
  alignItems: 'center',
})

export const EmployeeCount = styled.div({
  display: 'flex',
  gap: '4px',
})

export const CountNumber = styled(Typography)({
  fontWeight: 'bold',
})

export const TitleContainer = styled.div({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '10px',
})
export const SyncIconWrapper = styled.div({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    opacity: 0.7,
  },
})

export const MigrationAlert = styled(Typography)({
  fontSize: '12px',
  backgroundColor: '#fdf9d5',
  padding: '4px',
  borderRadius: '4px',
  border: '1px solid rgb(255, 193, 59)',
})



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/styled/index.tsx